import { useState, useMemo } from 'react'
import { motion } from 'framer-motion'
import { IPhoneNumber, IPhoneNumberGroup } from '../../interface'
import { RealtorNumberItem } from '../RealtorNumberItem'
import { PhoneNumbers } from '../PhoneNumbers'
import { PhoneNumberSearchInput } from '../PhoneNumberSearchInput'
import { filterPhoneNumberGroups } from '../../utils'

interface ActiveNumbersViewProps {
   realtorNumber: IPhoneNumber
   groupedActivePhoneNumbers: IPhoneNumberGroup[]
   onChangeRealtorNumber: () => void
}

export const ActiveNumbersView = ({
   realtorNumber,
   groupedActivePhoneNumbers,
   onChangeRealtorNumber,
}: ActiveNumbersViewProps) => {
   const [searchQuery, setSearchQuery] = useState('')

   const filteredGroups = useMemo(
      () => filterPhoneNumberGroups(groupedActivePhoneNumbers, searchQuery),
      [groupedActivePhoneNumbers, searchQuery]
   )

   return (
      <div className="flex flex-col h-full">
         {/* Fixed Header Section */}
         <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="flex flex-col gap-y-6 flex-shrink-0"
         >
            <PhoneNumberSearchInput
               value={searchQuery}
               onChange={setSearchQuery}
               placeholder="Search Phone numbers"
            />
            <RealtorNumberItem
               number={realtorNumber}
               onChangeNumber={onChangeRealtorNumber}
               onDelete={() => {
                  console.log('Delete realtor number')
               }}
            />
         </motion.div>

         {/* Scrollable List Section */}
         <div className="flex-1 min-h-0 overflow-y-auto mt-6">
            {filteredGroups.length > 0 ? (
               <PhoneNumbers numberGroups={filteredGroups} />
            ) : (
               <div className="flex items-center justify-center py-12">
                  <p className="text-white/40 text-sm">
                     No phone numbers found
                     {searchQuery && ` for "${searchQuery}"`}
                  </p>
               </div>
            )}
         </div>
      </div>
   )
}
